import React, { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Environment, Lightformer, Float } from "@react-three/drei";
import * as THREE from "three";

function Knot() {
  const mesh = useRef();
  useFrame((state, delta) => {
    if (!mesh.current) return;
    mesh.current.rotation.y += delta * 0.25;
    // React to mouse pointer (normalized -1..1)
    const targetX = state.pointer.y * 0.5;
    const targetZ = state.pointer.x * 0.5;
    mesh.current.rotation.x = THREE.MathUtils.lerp(
      mesh.current.rotation.x,
      targetX,
      0.05
    );
    mesh.current.rotation.z = THREE.MathUtils.lerp(
      mesh.current.rotation.z,
      targetZ,
      0.05
    );
  });

  return (
    <Float speed={1.5} rotationIntensity={0.3} floatIntensity={0.6}>
      <mesh ref={mesh} scale={1.15}>
        <torusKnotGeometry args={[1, 0.32, 220, 32, 2, 3]} />
        <meshPhysicalMaterial
          color="#0a0a0a"
          metalness={1}
          roughness={0.08}
          clearcoat={1}
          clearcoatRoughness={0.05}
          envMapIntensity={2.2}
        />
      </mesh>
    </Float>
  );
}

function Studio() {
  return (
    <Environment resolution={256}>
      <group rotation={[0, 0, 0]}>
        <Lightformer
          form="rect"
          intensity={3}
          position={[0, 4, -6]}
          scale={[10, 6, 1]}
          color="#ffffff"
        />
        <Lightformer
          form="rect"
          intensity={2}
          position={[-5, 1, 2]}
          scale={[3, 8, 1]}
          rotation={[0, Math.PI / 2, 0]}
          color="#a1a1aa"
        />
        <Lightformer
          form="rect"
          intensity={2.5}
          position={[5, 1, 2]}
          scale={[3, 8, 1]}
          rotation={[0, -Math.PI / 2, 0]}
          color="#ffffff"
        />
        <Lightformer
          form="circle"
          intensity={4}
          position={[0, -3, 4]}
          scale={4}
          color="#52525b"
        />
      </group>
    </Environment>
  );
}

export default function ChromeArtifact() {
  return (
    <Canvas
      camera={{ position: [0, 0, 5], fov: 45 }}
      gl={{ antialias: true, alpha: true }}
      dpr={[1, 1.8]}
      data-testid="chrome-artifact-canvas"
    >
      <ambientLight intensity={0.2} />
      <Knot />
      <Studio />
    </Canvas>
  );
}
